export enum MainTableDataTypeEnum {
  Experiences = "EXPERIENCES",
  DevicePlayers = "DEVICE_PLAYERS",
  DevicePeripherals = "DEVICE_PERIPHERALS",
  Locations = "LOCATIONS",
  ContentCampaigns = "CONTENT_CAMPAIGNS",
  ContentPlaylists = "CONTENT_PLAYLISTS",
  AssetVideos = "ASSET_VIDEOS",
  AssetImages = "ASSET_IMAGES",
  AssetAudio = "ASSET_AUDIO",
  Deployments = "DEPLOYMENTS",
  Projects = "PROJECTS",
  Users = "USERS",
  Invitations = "INVITATIONS",
}

export enum DetailsTableDataTypeEnum {
  LocationExperiences = "LOCATION_EXPERIENCES",
  LocationPlayers = "LOCATION_PLAYERS",
  ContentCampaignItems = "CONTENT_CAMPAIGN_ITEMS",
  ContentPlaylistAssets = "CONTENT_PLAYLIST_ASSETS",
  DeploymentDeviceSyncs = "DEPLOYMENT_DEVICE_SYNCS",
  ExperiencePlayers = "EXPERIENCE_PLAYERS",
}
